<template>
  <div>
    <CallHelpTel />
  </div>
  <div>
    <Search @upateShowNews="searchByKeyword"></Search>
  </div>
  <div style="display: flex">
    <div class="pcBtn">
      <router-link :to="'/Publish_submit/61'" title="發表投稿">
        <img
          class="PulishC"
          src="../img/c_icon/PublishContribution.png"
          alt="在地經驗分享按鈕圖"
        />
        <img
          class="PulishC_hover"
          src="../img/c_icon/PublishContribution_hover.png"
          alt="在地經驗分享按鈕圖"
        />
        <p class="post">發表投稿</p>
      </router-link>
    </div>
    <div class="instructions">
      <DoubleLeftOutlined
        :style="{ fontSize: '1.4em' }"
      />投稿使用說明詳見此處唷!
    </div>
  </div>

  <template v-for="item in contribution.items" :key="item.id">
    <GrayBlock :article="item" justify="SubmitPage" />
  </template>

  <a-pagination
    v-model:current="contribution.pagination.current"
    v-model:total="contribution.pagination.total"
    v-model:pageSize="contribution.pagination.pageSize"
    @change="changePage"
    :style="{ fontSize: fontSize.p + 'em' }"
  ></a-pagination>
</template>

<script>
import CallHelpTel from "../components/Home/CallHelpTel.vue";
import { ref, reactive, inject } from "vue";
import GrayBlock from "../components/ContentBlock.vue";
import Search from "../components/Search.vue";
import { apiSeacontributor } from "@/api/api.js";
import { toArticleFormat } from "@/util/article";
import { message } from "ant-design-vue";
import { useStore } from "vuex";
export default {
  components: {
    GrayBlock,
    Search,
    CallHelpTel,
  },
  setup() {
    const store = useStore();
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    let keyword = ref("");
    keyword.value = store.getters["getSearchKeyword"];
    const searchByKeyword = (str) => {
      contribution.pagination.current = 1;
      keyword.value = str;
      fetchContributor();
    };

    const contribution = reactive({
      items: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
      },
    });
    const fetchContributor = async () => {
      try {
        store.dispatch("setSearchData", {
          keyword: keyword.value,
          page: contribution.pagination.current,
        });
        const {
          data: { contributors, currentPage, totalPage },
        } = await apiSeacontributor({
          keyword: keyword.value,
          page: contribution.pagination.current,
        });
        const items = contributors.map((d) => toArticleFormat(d));

        contribution.items = items;
        contribution.pagination.current = currentPage;
        contribution.pagination.total = totalPage * 10;
      } catch (error) {
        console.log(error);
        message.error("無法取得投稿資料");
      }
    };

    contribution.pagination.current = store.getters["getSearchPage"];
    fetchContributor();

    const changePage = (page, pageSize) => {
      contribution.pagination.pageSize = pageSize;
      contribution.pagination.current = page;
      fetchContributor();
    };

    return {
      contribution,
      changePage,
      fetchContributor,
      searchByKeyword,
      fontSize,
    };
  },
};
</script>

<style lang="scss" scoped>
.pcBtn {
  border: $main_color 2px solid;
  border-radius: 5px;
  width: 120px;
  padding: 5px;
  cursor: pointer;
  margin-right: 20px;
  margin-bottom: 15px;
  .PulishC {
    display: inline-block;
  }
  .PulishC_hover {
    display: none;
  }
  a {
    @include flex_center;
  }
  &:hover {
    background-color: $main_color;
    .PulishC_hover {
      display: inline-block;
    }
    .PulishC {
      display: none;
    }
    .post {
      color: $main_sec_color;
    }
  }
}
</style>
